import React from "react";
import {
  ItalicsOutlined,
  LinkOutlined,
  TextBoldOutlined,
  TextUnderlinedOutlined,
} from "@toddle-edu/ds-icons";

export const styles = {
  editorStyle: {
    outlineColor: "transparent",
    minWidth: "50px",
    minHeight: "20px",
  },
};

export const ELEMENT_TYPE_PARAGRAPH = "paragraph";
export const ELEMENT_TYPE_IMAGE = "image";
export const ELEMENT_TYPE_LINK = "link";

export const EDITOR_OPTION_BOLD = "formatBold";
export const EDITOR_OPTION_ITALIC = "formatItalic";
export const EDITOR_OPTION_UNDERLINED = "formatUnderline";

export const EDITOR_OPTION_LINK = "insertLink";

export const DEFAULT_EDITOR_TOOLBAR_OPTIONS = [
  EDITOR_OPTION_BOLD,
  EDITOR_OPTION_UNDERLINED,
  EDITOR_OPTION_ITALIC,
];

export const EDITOR_OPTION_DETAILS = {
  [EDITOR_OPTION_BOLD]: {
    format: "bold",
    icon: <TextBoldOutlined variant={"subtle"} />,
  },
  [EDITOR_OPTION_UNDERLINED]: {
    format: "underlined",
    icon: <TextUnderlinedOutlined variant={"subtle"} />,
  },
  [EDITOR_OPTION_ITALIC]: {
    format: "italic",
    icon: <ItalicsOutlined variant={"subtle"} />,
  },
  [EDITOR_OPTION_LINK]: {
    icon: <LinkOutlined variant={"subtle"} />,
  },
};
